import { ContainerElement } from '@typedream/core';
import classNames from 'classnames';
import { memo } from 'react';
import { Dropdown, DropdownItem } from '../../../../components/Dropdown';
import { useTPlateEditorRef } from '../../../../plate';
import { setContainerStyle } from '../../../../nodes/container/transforms';
import { getSelectedElementEntry } from '../../../../plugins/elementSelection';
import { useDreamEditorStore } from '../../../../plugins/store';
import toolbarStyles from '../../SideToolbar.module.css';
import styles from './ContainerStyle.module.css';

const styleOptions: ContainerElement['style'][] = ['plain', 'card'];
const defaultStyle = styleOptions[0];

function ContainerStyle() {
  const editor = useTPlateEditorRef();

  const currentStyle = useDreamEditorStore(() => {
    const entry = getSelectedElementEntry<ContainerElement>(editor);
    return entry?.[0].style || defaultStyle;
  });

  return (
    <div className={toolbarStyles.section}>
      <span className={toolbarStyles.label}>Container Style</span>
      <Dropdown
        triggerLabel={<div className="is-capitalized">{currentStyle}</div>}
      >
        {styleOptions.map((s) => (
          <DropdownItem key={s}>
            <div
              role="none"
              className="is-flex is-align-items-center is-capitalized"
              onClick={() => {
                const path = getSelectedElementEntry(editor)?.[1];
                if (path) {
                  setContainerStyle(editor, path, s);
                }
              }}
            >
              <div className={styles.styleShowcase}>
                <div
                  className={classNames(
                    s === 'card' ? styles.card : styles.plain,
                  )}
                />
              </div>

              <span>{s}</span>
            </div>
          </DropdownItem>
        ))}
      </Dropdown>
    </div>
  );
}

export default memo(ContainerStyle);
